import {CHART_COLORS} from "@/consts/consts";
import moment from "moment";
import {Filters} from "@/models/Filters";

export function chunk (arr: Array<any>, len: number) : Array<Array<any>> {

  var chunks = [],
    i = 0,
    n = arr.length;

  while (i < n) {
    chunks.push(arr.slice(i, i += len));
  }

  return chunks;
}

export function clone(obj: object){
    return JSON.parse(JSON.stringify(obj))
}

export function toArray(obj: Object) :Array<any> {
  return  Object.keys(obj).map( k => obj[k as keyof typeof obj] )
}
//https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
export function uuidv4(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function downloadAs(uri: string, filename: string) : void {

  var link = document.createElement('a');

  if (typeof link.download === 'string') {

    link.href = uri;
    link.download = filename;

    //Firefox requires the link to be in the body
    document.body.appendChild(link);

    //simulate click
    link.click();

    //remove the link when done
    document.body.removeChild(link);

  } else {

    window.open(uri);

  }
}

export function arrayToCsv (rows: Array<any>){
  return "data:text/csv;charset=utf-8,"
      + rows.map(e => e.join(",")).join("\n");
}

export function isDevEnv(){
  return  process.env.NODE_ENV === 'development';
}

export function isMobile() {
    return window.innerWidth <= 960;
}

export let setCategoriesColor = (categories:Array<string>) => {
  return categories.map((value, index) => {return {
   category:value,
   color:CHART_COLORS[index]
  }
  })
}

function setFilterUrlParam(){

}

export function syncFiltersToUrl(filters:Filters) {
  if (history.pushState) {
    let searchParams = new URLSearchParams(window.location.search);
    if (filters.category !== undefined) searchParams.set('vertical', filters.category ? filters.category.code.toString() : 'ALL')
    if (filters.region !== undefined) searchParams.set('region', filters.region? filters.region.code.toString() : 'GG')
    if (filters.period !== undefined) searchParams.set('period', filters.period? filters.period.code.toString() : '')
    if (filters.prevPeriod !== undefined) searchParams.set('prevPeriod', filters.prevPeriod || '')
    if (filters.includeWoWValues !== undefined) searchParams.set('compare', filters.includeWoWValues ? filters.includeWoWValues.toString() : '0')

    let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    window.history.pushState({path: newurl}, '', newurl);
  }
}

export function getFilterCodesFromUrl() : {period: string, category: string, region: string, prevPeriod: string, includeWoWValues: number} {

  const searchParams = new URLSearchParams(window.location.search);

  const codes = {
    category: searchParams.get('vertical') || 'ALL',
    region: searchParams.get('region') || 'GG',
    period: searchParams.get('period') || '',
    prevPeriod: searchParams.get('period'),
    includeWoWValues: Number(searchParams.get('compare') || 0),

  }
  return codes
}

export class Utils {
  constructor() {
  }
   public static dateFormat(date: Date) {
    return moment(date).format('MMMM DD YYYY').toString();
  }
  public static datePreviousFormat= function (date: Date) {
    return moment(date).subtract(7, "days").format('MMMM DD YYYY').toString();
  }

  public static splitAndMergedArr(array: Array<any>){
    let merged = []
    const halfwayThrough = Math.floor(array.length / 2)
    const arrayFirstHalf = array.slice(0, halfwayThrough);
    const arraySecondHalf = array.slice(halfwayThrough, array.length);

    for (let i = 0; i < halfwayThrough; i++) {
      merged.push(...[arrayFirstHalf.shift(),arraySecondHalf.shift()])
    }
    return merged
  }

  public static sendAnalyticsEvent(event: any){
    const dataLayer = (window as any)['dataLayer'] as any
    dataLayer && dataLayer.push(event);
  }

}
//please do not delete.
(window as any).generateSiteMap = function(){

  const regions = ['GG']
  const verticals = ["ALL", "AUTO", "CPG", "EDU", "FASH", "FIN", "GOV", "HEALTH", "LIFES", "MANUF", "MEDIA", "TECH", "TRAVEL"]

  const urls:string[] = []

  regions.forEach(r => {

    verticals.forEach(v => {
        urls.push(`<url><loc>https://www.outbrain.com/brainpower/vertical-insights?region=${r}&amp;vertical=${v}</loc></url>`)
    })

  })
 console.log(urls.length)
  return urls.join('')
}

